import Loading from "vue-loading-overlay";
import $ from 'jquery';

export default {
    name: "BuyDeviceProductDetails",
    components: {
        Loading
    },
    data() {
        return {
            isLoading: false,
            fullPage: true,
            loader: "bars",
            productData: [],
            product_view_type_grid: 'active',
            product_view_type_list: '',
            product_view_class: 'col-xs-12 col-md-3 col-lg-3 mb-4 cat-block-device',
            product_view_inner_image_class: 'col-lg-12 col-sm-12 col-md-12 col-xs-12 p-0',
            product_view_inner_block_class: 'col-lg-12 col-sm-12 col-md-12 col-xs-12',
            product_view_list_row_class: '',
            product_view_price_cart_class: '',
            product_view_image_margin_top: 'margin-top:20px; height:120px;',
            product_view_gird_hide: false,
            purchase_quantity: 1,
            purchase_rating: 0,
            purchase_product_id: 0,
            purchase_review: [],
            review_fullname: '',
            review_email: '',
            review_message: '',
            imagePath: this.$api + "assets/buy/device/info/",
            carrierImagePath: this.$api + "assets/buy/device/carrier/",
            storageImagePath: this.$api + "assets/buy/device/stroage/",
            setAddToCartPurchaseUrl: this.$api + 'api/purchase/add-to-cart',
            purchaseProductCart:{items:[],total_quantity:0,total_price:0},
        }
    },
    mounted() {
        $('#range-picker div').on('click', function() {
            $('#range-picker div').each(function(key, row) {
                if($(row).hasClass('active'))
                {
                    $(row).removeClass('active');
                }
            });
            $(this).addClass('active');
        });

        $(".carrier-box div").on('click',function(){
            $(".carrier-box div").each(function(key,row){
                if($(row).hasClass('active'))
                {
                    $(row).removeClass('active');
                }
            });
            $(this).addClass('active');
        });

        $(".condition-box div").on('click',function(){
            $(".condition-box div").each(function(key,row){
                if($(row).hasClass('active'))
                {
                    $(row).removeClass('active');
                }
            });
            $(this).addClass('active');
        });

        $(".stroage-box div").on('click',function(){
            $(".stroage-box div").each(function(key,row){
                if($(row).hasClass('active'))
                {
                    $(row).removeClass('active');
                }
            });
            $(this).addClass('active');
        });

        $('#color-a.color').on('click', function() {
            $('#color-overlay').css('transform','translateX(-0.5px)');
            $('#background-element').css('backgroundColor','#333');
            $('#highlight-overlay').css('opacity','1');
            $('#highlight-overlay-mobile').css('opacity','1');
            $('#color-name').html("BLACK / 050");
            $('#color-name').css('color','#333');
        });

        $('#color-b.color').on('click', function() {
            $('#color-overlay').css('transform','translateX(45px)');
            $('#background-element').css('backgroundColor','#457');
            $('#highlight-overlay').css('opacity','0');
            $('#highlight-overlay-mobile').css('opacity','0');
            $('#color-name').html("BLUES / 2V5");
            $('#color-name').css('color','#457');
        });

        $('.tabbed li').on('click',function(){
            console.log("Tab Click");
            $('.tabbed li').each(function(key, row){
                if($(row).hasClass('active'))
                {
                    $(row).removeClass('active');
                }
            });

            $(".buyphone-tab-content").hide();

            $(this).addClass('active');
            let tabContent = $(this).attr('data-id');
            $("#"+tabContent).show();

            $(".rating-review").mouseover(function() {
                let current_rate=$(this).attr('data-id');
                console.log('current_rate = '+current_rate);
                $('.rating-review').each(function(index,row){
                    let linum=$(row).attr('data-id');
                    if(linum<=current_rate)
                    {
                        $(row).addClass('fa-star-gold');
                    }
                    
                });
            })
            .mouseout(function() {
                let current_rate=$(this).attr('data-id');
                console.log('current_rate out = '+current_rate);
                $('.rating-review').each(function(index,row){
                    let linum=$(row).attr('data-id');
                    if(linum<=current_rate)
                    {
                        $(row).removeClass('fa-star-gold');
                    }
                    
                });
            });
        });
        $(".buyphone-tab-content:eq(0)").show();
    },
    created() {
        document.title = "Buy A Device - Product Details";
        this.getPurchaseProductDetails({
            "url": "api/purchase/product/detail/json", 
            "param": {
                "identifier": this.$route.params.identifier
            }
        });
    },
    methods: {
        showMessage: function(typeMessage, title, detailMessage) {
            this.$swal.fire(
                title,
                detailMessage,
                typeMessage
            );
            return false;
        },
        increasePurcaseProductQuantity: function() {
            this.purchase_quantity++;
        },
        decreasePurcaseProductQuantity: function() {
            if(this.purchase_quantity > 1)
            {
                this.purchase_quantity--;
            }  
        },
        chooseReviewRating: function(rating) {
            this.purchase_rating = rating;
            $('.rating-review').each(function(index, row){
                if($(row).hasClass('fa-star-gold-active'))
                {
                    $(row).removeClass('fa-star-gold-active');       
                }    
            });
            $('.rating-review').each(function(index, row){
                let linum = $(row).attr('data-id');
                if(linum <= rating)
                {
                    $(row).addClass('fa-star-gold-active');
                }
            });
        },
        getPurchaseProductDetails: function(obj) {
            this.isLoading = true;
            this.$axios.post(this.$api + obj.url, obj.param)
            .then(response => {
                this.productData = response.data;
                let dataSpec = this.productData.product.device_specification;
                this.purchase_product_id = this.productData.product.id;
                this.purchase_review = this.productData.reviewData;
                $("#product_specification").html(dataSpec);
                this.isLoading = false;
            })
            .catch(e => {
                console.log(e);
                this.isLoading = false;
            });
        },
        saveUserReview: function() {
            if(this.review_fullname.length == 0) {
                this.showMessage('error', 'Required Field Missing!', 'Please enter full name');
                return false;
            }
            if(this.review_email.length == 0) {
                this.showMessage('error', 'Required Field Missing!', 'Please enter email');
                return false;
            }
            if(this.review_message.length == 0) {
                this.showMessage('error', 'Required Field Missing!', 'Please enter review message');
                return false;
            }
            if(this.purchase_rating == 0) {
                this.showMessage('error', 'Required Field Missing!', 'Please choose your rating out of five');
                return false;
            }
            let obj = {'url': 'api/purchase/product/detail/save/review', 'param': {
                    'fullname': this.review_fullname,
                    'email': this.review_email,
                    'review_message': this.review_message,
                    'rating': this.purchase_rating,
                    'product_id': this.purchase_product_id,
                }
            };
            this.isLoading = true;
            this.$axios.post(this.$api + obj.url, obj.param)
            .then(response => {
                let data = response.data;
                this.isLoading = false;
                if(data.status == 1) {
                    this.showMessage("success", "Review Submitted.", "Thank you for submitting your review.");
                    this.purchase_rating = 0;
                    this.review_fullname = '';
                    this.review_email = '';
                    this.review_message = '';
                }
            })
            .catch(e => {
                console.log(e);
                this.isLoading = false;
            });
        },
        setProductTypeView: function(viewName) {
            if(viewName == "grid") {
                this.product_view_type_grid = 'active';
                this.product_view_type_list = '';
                this.product_view_class = 'col-xs-12 col-md-3 col-lg-3 mb-4 cat-block-device';
                this.product_view_inner_image_class = 'col-lg-12 col-sm-12 col-md-12 col-xs-12 p-0';
                this.product_view_inner_block_class = 'col-lg-12 col-sm-12 col-md-12 col-xs-12';
                this.product_view_list_row_class = '';
                this.product_view_price_cart_class = '';
                this.product_view_image_margin_top = 'margin-top: 20px; height: 120px;';
                this.product_view_gird_hide = false;
            }
            else if(viewName == "list") {
                this.product_view_type_grid = '';
                this.product_view_type_list = 'active';
                this.product_view_class = 'col-xs-12 col-md-12 col-lg-12 mb-4 cat-block-device';
                this.product_view_inner_image_class = 'col-lg-3 col-sm-12 col-md-3 col-xs-12 p-0';
                this.product_view_inner_block_class = 'col-lg-6 col-sm-12 col-md-9 col-xs-12 pt-4';
                this.product_view_list_row_class = 'row pt-4';
                this.product_view_price_cart_class = 'display:none !important;';
                this.product_view_image_margin_top = 'margin-top: 0px; height: 120px; margin-bottom: 10px;';
                this.product_view_gird_hide = true;
            }
            else {
                this.product_view_type_grid = 'active';
                this.product_view_type_list = '';
                this.product_view_class = 'col-xs-12 col-md-3 col-lg-3 mb-4 cat-block-device';
                this.product_view_inner_image_class = 'col-lg-12 col-sm-12 col-md-12 col-xs-12 p-0';
                this.product_view_inner_block_class = 'col-lg-12 col-sm-12 col-md-12 col-xs-12';
                this.product_view_list_row_class = '';
                this.product_view_price_cart_class = '';
                this.product_view_image_margin_top = 'margin-top: 20px; height: 120px;';
                this.product_view_gird_hide = false;
            }
        },
        addToPurcaseCart(deviceImage){

            if(localStorage.getItem('purchase_cart'))
            {
                console.log('Before Parse ',localStorage.getItem('purchase_cart'));
                if(localStorage.getItem('purchase_cart')==null)
                {
                    this.purchaseProductCart.total_price=0;
                    this.purchaseProductCart.total_quantity=0;
                    this.purchaseProductCart.items=[];

                    let purchaseProductCartString=JSON.stringify(this.purchaseProductCart);
                    console.log('Type of object = ',typeof(purchaseProductCartString));

                    localStorage.setItem('purchase_cart',this.purchaseProductCartString);
                }
                else
                {
                    if(localStorage.getItem('purchase_cart').length>0)
                    {
                        let oldCart=JSON.parse(localStorage.getItem('purchase_cart'));
                        console.log('oldCart = ',oldCart);
                        if(oldCart!=null)
                        {
                            if(oldCart.items!== undefined)
                            {
                                this.purchaseProductCart=oldCart;
                                console.log("Local Stroage Not Empty");
                                console.log(oldCart.items);
                            }
                            else
                            {
                                console.log("Local Stroage Empty");
                            }
                        }
                        else
                        {
                            this.purchaseProductCart.total_price=0;
                            this.purchaseProductCart.total_quantity=0;
                            this.purchaseProductCart.items=[];

                            let purchaseDeviceCartString=JSON.stringify(this.purchaseProductCart);
                            console.log('Type of object = ',typeof(purchaseDeviceCartString));

                            localStorage.setItem('purchase_cart',purchaseDeviceCartString);
                        }
                        
                    }
                    else
                    {
                        console.log("Local Stroage Empty");
                    }
                }
                
                
            }
            else
            {
                this.purchaseProductCart.total_price=0;
                this.purchaseProductCart.total_quantity=0;
                this.purchaseProductCart.items=[];

                let purchaseProductCartString=JSON.stringify(this.purchaseProductCart);
                console.log('Type of object = ',typeof(purchaseProductCartString));

                localStorage.setItem('purchase_cart',purchaseProductCartString);
            }

            //this.$store.state.pageLoader = true;
            console.log(this.purchaseProductCart);
            //this.$emit('updatePurchaseCartBox', "+"+this.purchase_quantity); 
            let formData = new FormData();
                formData.append('pro_id', this.purchase_product_id);
                formData.append('pro_quantity', this.purchase_quantity);
            console.log(formData);    

            if(this.purchaseProductCart.length>0)
            {
                const checkCartItem = this.purchaseProductCart.items.filter(item => item.cart_id===this.purchase_product_id); 
                if(checkCartItem.length > 0){
                    console.log('Item is already available');
                }
            }
            else
            {
                this.purchaseProductCart={items:[],total_quantity:0,total_price:0};
            }
            console.log(this.purchaseProductCart);

            this.$axios.post(this.setAddToCartPurchaseUrl, formData)
            .then(response => {
                console.log(response.data);
                let data = response.data;
                let cartOld={};
                let checkStatus=[];
                let checkStatusIndex=null;
                console.log('Axios Local= ',localStorage.getItem('purchase_cart'));
                if(localStorage.getItem('purchase_cart').length>0)
                {
                    console.log('Session checking = ');
                    cartOld=JSON.parse(localStorage.getItem('purchase_cart'));
                    let oldCartItem=cartOld.items;
                    if(oldCartItem.length > 0)
                    {
                        checkStatus=oldCartItem.filter(item => item.cart_id==this.purchase_product_id);
                        console.log('Session Filter = ',checkStatus.length);
                        oldCartItem.forEach((t,index)=>{
                            console.log('Looping = ',t, index);
                            if(t.cart_id==this.purchase_product_id)
                            {
                                checkStatusIndex=index;
                            }
                        });
                    }
                }

                console.log('Item Index Found = ',checkStatusIndex);

                console.log('checkStatus = ',checkStatus);
                if(checkStatus.length > 0){
                    
                    console.log('Item found on filter');
                    cartOld.total_price+=(data.device_price*this.purchase_quantity);
                    cartOld.total_quantity+=this.purchase_quantity;
                    cartOld.items[checkStatusIndex].qty+=this.purchase_quantity;
                    cartOld.items[checkStatusIndex].price+=(data.device_price*this.purchase_quantity);
                }
                else
                {
                    console.log('Item not found on filter');
                        console.log('cartOld = ', cartOld);

                        if(cartOld.items==0)
                        {
                            cartOld.items=[];
                        }

                        cartOld.items.push({
                            'cart_id':data.pro_id,
                            'name':data.product.device_name,
                            'unit_price':data.device_price,
                            'price':(data.device_price*this.purchase_quantity),
                            'qty':this.purchase_quantity,
                            'deviceImage':deviceImage,
                            'item':data.product
                        });
                        cartOld.total_price+=(data.device_price*this.purchase_quantity);
                        cartOld.total_quantity+=this.purchase_quantity;
                        this.$emit('updatePurchaseCartBox', cartOld.total_quantity);  
                }

                let purchaseProductCartString=JSON.stringify(cartOld);
                console.log('Type of object = ',typeof(purchaseProductCartString));

                localStorage.setItem('purchase_cart',purchaseProductCartString);
                console.log('this.sellDeviceCart Updated=',purchaseProductCartString);
                console.log('this.sellDeviceCart stroiage=',localStorage.getItem('purchase_cart'));

                //let res=response.data;
                //this.$emit('updatePurchaseCartBox', res.totalQty);  
                //this.loadStatus = true;
                //this.$store.state.pageLoader = false;

                //this.$router.push({name:'buyCartBox'});

                this.$router.push({name:'Cart'});
            })
            .catch(e => {
                console.log(e);
            });
            
        }
    }
}